module.exports = __webpack_public_path__ + "img/vmc.fb6b8931.png";